const messages = {
  title: "Kuponger",
  short_description:
    "Her finner du kuponglisten din. Du kan dele med kunden din. Kuponger kan kun brukes én gang.",
  table: {
    headers: {
      voucher: "Kupongkoder",
      company: "Selskap",
      street: "Gate",
      postcode: "Postnummer",
      location: "Sted",
      solved_at: "Dato",
      points: "Antall poeng via koden",
    },
  },
  exchange: {
    title: "Skriv inn koden din for å få poeng",
    pointsLabel: "Skriv inn koden her:",
    result: "Antall poeng:",
  },
};

export default {
  messages,
};
